
import {
  createComponent,
  reactive,
  computed,
  inject,
} from "@vue/composition-api";
import { eLevel, convertLevelToEnum, levelDataList } from "@/lib/typeWell";
import ConfigStoreKey from "./config-store-key";
import { clamp, step } from "@/lib/utils";

export default createComponent({
  setup() {
    const configStore = inject(ConfigStoreKey);
    if (!configStore) {
      throw new Error(`${ConfigStoreKey} is not provided`);
    }

    const state = reactive({
      // カウントダウンの秒数（1以上3以下）
      countdownTime: computed({
        get: (): number => {
          return configStore.countdownTime;
        },
        set: (newVal: number) => {
          newVal = step(clamp(newVal, 1, 3), 1);
          configStore.setCountdownTime(newVal);
        },
      }),
      // 目標レベル
      targetLevel: computed({
        get: (): string => {
          return eLevel[configStore.targetLevel];
        },
        set: (newLevelStr: string) => {
          const enumTargetLevel: eLevel = convertLevelToEnum(newLevelStr);
          configStore.setTargetLevel(enumTargetLevel);
        },
      }),
      // ミスの上限回数（0以上255以下）
      missMax: computed({
        get: (): number => {
          return configStore.missMax;
        },
        set: (newVal: number) => {
          newVal = step(clamp(newVal, 0, 255), 1);
          configStore.setMissMax(newVal);
        },
      }),
      // 目標ゲージ（青）の秒数
      // ミリ秒ではない！！！
      fastTargetBoxTime: computed({
        get: (): number => {
          return configStore.fastTargetBoxTimeMs / 1000;
        },
        set: (time: number) => {
          let timeMs = time * 1000;
          timeMs = step(clamp(timeMs, 10, 10 * 1000), 10);
          configStore.setFastTargetBoxTimeMs(timeMs);
        },
      }),
      // 目標ゲージ（黄・赤）の秒数
      // ミリ秒ではない！！！
      slowTargetBoxTime: computed({
        get: (): number => {
          return configStore.slowTargetBoxTimeMs / 1000;
        },
        set: (time: number) => {
          let timeMs = time * 1000;
          timeMs = step(clamp(timeMs, 10, 10 * 1000), 10);
          configStore.setSlowTargetBoxTimeMs(timeMs);
        },
      }),
    });

    return {
      state,
      levelDataList,
    };
  },
});
